import { Component, NgModule, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DxGanttModule, DxGanttComponent } from 'devextreme-angular/ui/gantt';
import { exportGantt as exportGanttToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';

import 'jspdf-autotable';
import { Task } from '../task';

@Component({
  selector: 'dk-task-list-gantt',
  templateUrl: './task-list-gantt.component.html',
  styleUrls: ['./task-list-gantt.component.scss'],
  standalone: true,
  imports: [DxGanttModule, CommonModule],
})
export class TaskListGanttComponent {
  @ViewChild(DxGanttComponent, { static: false }) gantt: DxGanttComponent;
  @Input() dataSource: Task[];

  constructor(private router: Router) {}

  refresh() {
    this.gantt.instance.refresh();
  }

  onExporting() {
    exportGanttToPdf({
      component: this.gantt.instance,
      createDocumentMethod: (args?: any) => new jsPDF(args),
    }).then((doc) => doc.save('Tasks.pdf'));
  }

  navigateToDetails = () => {
    this.router.navigate(['/main/task/detail']);
  };
}
